/*eslint-disable */
import moment from "moment";
import regex from "src/helpers/regex";
import * as yup from "yup";

export interface IProposalPayment {
  nameofPolicyHolder: string;
  place: string;
  date: string;
  signature: string;
  // jointSignature: string;
  declaration: any;
}

export const validationSchema = () =>
  yup.object().shape<Record<keyof IProposalPayment, yup.AnySchema>>({
    nameofPolicyHolder: yup.string().required("Name of Policy Holder is Required"),
    place: yup.string().required("Place is Required").matches(regex.fullName, "Invalid Place"),
    date: yup
      .string()
      .required("Date is Required")
      .test("is-valid-date", "Invalid date", (value) => moment(value, "DD/MM/YYYY").isValid())
      .default(""),
    signature: yup.string().trim(),
    // jointSignature: yup.string().trim(),
    declaration: yup.bool()
    // signature: yup.string().trim().required("Signature/Thumb Impression is Required"),
    // declaration: yup.bool().required("You need to accept the Declaration")
  });
